import { get } from "lodash";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  setLoggedUser,
  setPageLoading,
  setReloadProfilePic,
} from "./app/commonSlice";
import Container from "./app/common-components/Container";
import ContainerLoader from "./app/common-components/ContainerLoader";
import { setRedirectPath } from "./app/utilities/helpers";
import { getLandingPath } from "./app/rbac/restrictedUsers";
import Cookies from "universal-cookie";
import GetProxy from "./app/GetProxy";

const PrivateRoute = (props) => {
  const proxy = GetProxy(false);
  const cookies = new Cookies();
  const location = useLocation();
  const pathName = get(location, "pathname", "");
  const { loggedUser, pageLoading, reloadProfilePic } = useSelector(
    (state) => state.common,
  );
  const { userName, userRole, token } = loggedUser;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const checkUserAccess = (userRole) => {
    if (
      document.title === "celcomdigi - Access Denied" &&
      pathName !== "/access-denied"
    ) {
      document.title = "celcomdigi";
    }
    // if (userRole?.trim() === "User") {
    //   const matchedPathIndex = userRestrictedAccess.indexOf(pathName);
    //   if (matchedPathIndex !== -1) {
    //     navigate("/access-denied");
    //     return false;
    //   }
    // }
    pathName === "/" && navigate(getLandingPath(userName, userRole));
    dispatch(setPageLoading(false));
  };
  const jwttoken = cookies.get("jwttoken");
  const refershtoken = cookies.get("Refersh");
  const sessionToken = useSelector((state) => state.common.sessionToken);
  const getLoggedUser = async () => {
    const cookies = new Cookies();
    await fetch(`${proxy}/getTopHeader`, {
      method: "GET",
      redirect: "manual",
      cache: "no-store",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: jwttoken,
        "Refresh-Token": refershtoken,
      },
    })
      .then((data) => {
        if (data.status === 200) {
          setRedirectPath();
          return data.json();
        }
      })
      .then((response) => {
        if (
          response.refreshToken !== "undefined" &&
          pathName !== "/" &&
          refershtoken !== null
        ) {
          const userName = response.encodedUsername;
          const userRole = response.role;
          const primaryRole = response.primaryRole;
          const displayName = response.displayName;
          const token = response.token;
          const refreshToken = response.refreshToken;
          const usersProfilePic = response.imageUrl;
          dispatch(
            setLoggedUser({
              userName,
              userRole,
              primaryRole,
              token,
              displayName,
              usersProfilePic,
            }),
          );
          sessionStorage.setItem("isLoggedin", true);
          if (sessionToken === false) {
            cookies.set("apitoken", token, { path: "/" });
          }

          cookies.set("username", userName, { path: "/" });
          cookies.set("referstoken", refreshToken, { path: "/" });
          return;
        } else {
          cookies.remove("jwttoken", { path: "/" });
          cookies.remove("Refersh", { path: "/" });
          cookies.remove("apitoken", { path: "/" });
          cookies.remove("username", { path: "/" });
          cookies.remove("referstoken", { path: "/" });
          sessionStorage.setItem("lastVistedURL", pathName);
          sessionStorage.setItem("isLoggedin", false);
          navigate("/auth");
        }
      })
      .catch((error) => {
        navigate("/auth");
      });
  };

  useEffect(() => {
    getLoggedUser();
  }, []);

  useEffect(() => {
    if (reloadProfilePic) {
      getLoggedUser();
      dispatch(setReloadProfilePic());
    }
  }, [reloadProfilePic]);

  useEffect(() => {
    if (pathName === "/access-denied") {
      document.title = "celcomdigi - Access Denied";
    }
    userName !== "" &&
      userRole?.length !== 0 &&
      token !== "" &&
      checkUserAccess(userRole);
  }, [pathName, userName, userRole, token, pageLoading]);

  // To eyeball the loader without waiting for a slow load, flip this on:
  // const FORCE_LOADER = true;  // then use `pageLoading || FORCE_LOADER` below.
  return <>{pageLoading ? <ContainerLoader /> : <Container />}</>;
};

export default PrivateRoute;
